'use client'

import { useEffect } from 'react'

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
  children?: React.JSX.Element
}) {
  useEffect(() => {
    // Log the error to an error reporting service
    // eslint-disable-next-line no-console
    console.error('Client side error caught by ErrorBoundary', { error })
  }, [error])

  return (
    <div>
      <h2>Something went wrong!</h2>
      <pre style={{ color: 'red' }}>{error?.stack}</pre>
      <button
        onClick={
          // Attempt to recover by trying to re-render the segment
          () => reset()
        }
      >
        Try again
      </button>
    </div>
  )
}
